import { SelectionChangeResponse, Tree, TreeSearch, TreeSummary, TypeCounter } from "@rio-cloud/rio-uikit";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { IFilterOptions } from "../useAssetTree";

interface IVehicleTree {
  filterOptions: IFilterOptions;
  selectedVehicles: string[];
  setSelectedVehicles: (items: string[]) => void;
}

const VehicleTree = ({ filterOptions, selectedVehicles, setSelectedVehicles }: IVehicleTree) => {
  const [searchValue, setSearchValue] = useState("");

  const formatVehicles =
    filterOptions?.vehicles.map((vehicle) => ({
      id: vehicle.id,
      name: vehicle.label,
      type: "van-baseline",
    })) || [];

  const filteredVehicles = formatVehicles.filter((vehicle) =>
    get(vehicle, "name", "").toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleSelectVehicle = ({ items }: SelectionChangeResponse) => setSelectedVehicles(items);

  const handleUpdateSearch = (value: string) => setSearchValue(value);

  return (
    <Tree
      items={filteredVehicles}
      selectedItems={selectedVehicles}
      onSelectionChange={handleSelectVehicle}
      hasMultiselect={!isEmpty(filteredVehicles)}
      summary={
        <TreeSummary>
          <TypeCounter icon="rioglyph rioglyph-van-baseline" value={filteredVehicles.length} />
        </TreeSummary>
      }
      search={<TreeSearch value={searchValue} placeholder="busca em veículo" onChange={handleUpdateSearch} />}
    />
  );
};

export default VehicleTree;
